import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

export const fetchReport = createAsyncThunk(
    'report/fetch',
    async ({ type, params }, { rejectWithValue }) => {
        try {
            // type could be 'daily-recharge', 'invoice', etc.
            // Adjust the endpoint mapping as per actual API structure
            const response = await axiosInstance.get(`/admin/reports/${type}`, { params });
            return { type, data: response.data };
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || `Failed to fetch ${type} report`);
        }
    }
);

const reportSlice = createSlice({
    name: 'report',
    initialState: {
        data: {}, // { reportType: [records] }
        loading: false,
        error: null,
        pagination: {},
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchReport.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchReport.fulfilled, (state, action) => {
                state.loading = false;
                state.data[action.payload.type] = action.payload.data?.data || [];
                state.pagination[action.payload.type] = action.payload.data?.pagination || {};
            })
            .addCase(fetchReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default reportSlice.reducer;
